import { Box, Grid, Typography } from '@mui/material';
import { DriverDetails, DriverExcess as DriverExcessAPI } from '@acorn-portal/shared/src/services/api';

import Price from './price';

interface IDriverExcess {
	drivers: DriverDetails[];
	driverExcesses?: DriverExcessAPI[];
}

const DriverExcess = ({ drivers, driverExcesses }: IDriverExcess) => {
	const getCompulsoryAmount = (dataPointId: string) => {
		const driverExcess = driverExcesses?.find((excess) => excess.dataPointId === dataPointId);

		return driverExcess?.compulsoryAmount ?? 0;
	};

	return (
		<Box sx={{ width: '100%' }}>
			<Typography fontWeight='bold'>Driver Excesses</Typography>
			<Typography sx={{ paddingTop: 2, fontStyle: 'italic' }}>
				Any driver excess shown below are in addition to any excess detailed above
			</Typography>
			{drivers.map((driver) => (
				<Grid container alignItems='center' sx={{ py: 2 }} gap={2} key={driver.dataPointId}>
					<Grid flex={1}>
						<Typography>
							{driver.firstName} {driver.lastName}
						</Typography>
					</Grid>
					<Grid>
						<Price value={getCompulsoryAmount(driver.dataPointId)} description='Compulsory Excess' />
					</Grid>
				</Grid>
			))}
		</Box>
	);
};

export default DriverExcess;
